export default "__VITE_ASSET__C1kPfz8j__"